import isNumber from './is-number';
var isInteger = Number.isInteger ? Number.isInteger : function (num) {
    return isNumber(num) && num % 1 === 0;
};
export default isInteger;
//# sourceMappingURL=is-integer.js.map